<template>
  <div>
    <home></home>
  </div>
</template>
<script>
import Home from "./Home";
export default {
  components: {
    Home
  }
};
</script>
